var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-cabinet-referral-info"},[_c('section',{staticClass:"page-cabinet-referral-info__link"},[_c('page-cabinet-referral-info-link')],1),(_vm.getReferralsResult && _vm.getReferralsResult.length > 0)?_c('section',{staticClass:"page-cabinet-referral-info__list"},[_c('page-cabinet-referral-info-list')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }